import { useMemo } from "react";
import { getEnvExperimentalFeatures } from "../helpers/env";
import { Settings } from "../helpers/settings";
import { useSettings } from "./settings";

const envEnabledFeatures = (getEnvExperimentalFeatures() ?? "").split(",");

const envExperimentalFeatures: Settings["experimental"] = {};
envEnabledFeatures.forEach((feature) => {
  if (feature) (envExperimentalFeatures as any)[feature] = true;
});

export const useExperimentalFeatures = (): NonNullable<Settings["experimental"]> => {
  const [settings] = useSettings();
  return useMemo(() => ({
    ...envExperimentalFeatures,
    ...(settings.experimental ?? {}),
  }), [settings.experimental]);
};